const INITIALIZE_VIEWS = 'view/INITIALIZE_VIEWS';
const RESET_DEFAULT_VIEW = 'view/RESET_DEFAULT_VIEW';
const UPDATE_FILTERS = 'view/UPDATE_FILTERS';
const UPDATE_FILTER = 'view/UPDATE_FILTER';
const UPDATE_GENERIC_FILTER = 'view/UPDATE_GENERIC_FILTER';
const UPDATE_COLUMNS = 'view/UPDATE_COLUMNS';
const MOVE_COLUMN = 'view/MOVE_COLUMN';
const RESIZE_COLUMN = 'view/RESIZE_COLUMN';
const UPDATE_SORT = 'view/UPDATE_SORT';
const SWITCH_VIEW = 'view/SWITCH_VIEW';
const TOGGLE_HIDE_CONFIGURATION = 'view/TOGGLE_HIDE_CONFIGURATION';
const SAVE_VIEW = 'view/SAVE_VIEW';
const DELETE_VIEW_SUCCESS = 'view/DELETE_VIEW_SUCCESS';
const SET_DEFAULT_VIEW_REQUEST = 'view/SET_DEFAULT_VIEW_REQUEST';
const SET_DEFAULT_VIEW_SUCCESS = 'view/SET_DEFAULT_VIEW_SUCCESS';

export default {
  INITIALIZE_VIEWS,
  RESET_DEFAULT_VIEW,
  UPDATE_FILTERS,
  UPDATE_FILTER,
  UPDATE_GENERIC_FILTER,
  UPDATE_COLUMNS,
  MOVE_COLUMN,
  RESIZE_COLUMN,
  UPDATE_SORT,
  SWITCH_VIEW,
  TOGGLE_HIDE_CONFIGURATION,
  SAVE_VIEW,
  DELETE_VIEW_SUCCESS,
  SET_DEFAULT_VIEW_REQUEST,
  SET_DEFAULT_VIEW_SUCCESS,
};
